/*
 * @Description:
 * @version:
 * @Author: lijing
 * @Date: 2022-05-26 16:38:34
 * @LastEditors: yangfan yangfan@caixm.cn
 * @LastEditTime: 2026-01-30 11:26:08
 */

import request from '../../utils/request';
/**
 * 支付进件列表查询接口
 * @param {objcet} params
 * @returns
 */
export async function fetchBankPayment(params) {
  return request({ url: `payEntryDataResource/list`, headers: 'json', method: 'post', params });
}
export async function addDownloadRecordRequest(params) {
  return request({
    url: `payEntryDataResource/addDownloadRecord`,
    headers: 'json',
    method: 'post',
    params,
  });
}
export async function generatePdfRequest(params) {
  return request({
    url: `payEntryData/summary/generatePdf`,
    headers: 'json',
    method: 'post',
    params,
  });
}
export async function exportBankPayment(params) {
  return request({
    url: `payEntryDataResource/list/download`,
    headers: 'json',
    method: 'post',
    params,
    responseType: 'blob',
  });
}
